import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/TeaserDeck/BrandCard/BrandCard.css';

export const prototypeName = 'bePk2rxzV1tbXy2DNjG5sK7vv4P1VlSko8e8kx3bIQRpWD1DxdHX5R57Qkl5h9ok3WvyAdI3XyP0kj4bUGrv8oNkabuDwdV';
export {styles};